<div class="community-map__map-inner" #map></div>
